const cardData = [
    {
        id: 1,
        imgSrc: "images/voice-project.png",
        title: "Voice Based Authentication",
        description: "Designed and implemented using HTML, CSS, JAVASCRIPT, Flask and Python to create an intuitive and user-friendly experience.",
        tech: ["HTML", "CSS", "JavaScript", "Flask", "Python"]
    },
    {
        id: 2,
        imgSrc: "images/vlabs-project.png",
        title: "Virtual Labs",
        description: "Designed and implemented using HTML, CSS, JAVASCRIPT, Flask and Python for students to perform experiments.",
        tech: ["HTML", "CSS", "JavaScript", "Flask", "Python"]
    },
    {
        id: 3,
        imgSrc: "images/todo-project.png",
        title: "Todo List App",
        description: "React app to create a personal todo list.",
        tech: ["HTML","CSS", "JavaScript" ,"React"]
    },
    {
        id: 4,
        imgSrc: "images/text-project.png",
        title: "Text Utils",
        description: "Implemented using React to analyze text and perform various operations on it.",
        tech: ["HTML", "CSS", "JavaScript", "React"]
    }
];

export default cardData;